import { createIcon } from '../createIcon.tsx';

export const StairsIcon = createIcon('StairsIcon', <polyline points="3 21 8 21 8 16 13 16 13 11 18 11 18 6 21 6" />);
